import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IKyloeCallIntegrationConfig {
  domains: string[];
  botName: string;
  active: boolean;
}

export interface IRingoverallIntegrationConfig {
  apiKey?: string;
  webhookKey?: string;
  tenantId?: string;
  enabled?: boolean;
}

export type IMaskedGlobalNotetakerConfig = {
  kyloeCall: IKyloeCallIntegrationConfig,
  ringover: Omit<IRingoverallIntegrationConfig, 'apiKey' | 'webhookKey'> & {
    isApiKeySet: boolean;
    isWebHookKeySet: boolean;
  };
};

export interface INoteTakerIntegrationConfig {
  kyloeCall: IKyloeCallIntegrationConfig;
  ringover: IRingoverallIntegrationConfig;
}

@Injectable({
  providedIn: 'root',
})
export class NoteTakerIntegrationApiService {
  private readonly baseUrl = environment.ntIntegrationApiUrl;
  constructor(private http: HttpClient) {}

  public getIntegrationConfig(): Observable<IMaskedGlobalNotetakerConfig> {
    return this.http.get<IMaskedGlobalNotetakerConfig>(`${this.baseUrl}/integration`);
  }

  public putIntegrationConfig(config: INoteTakerIntegrationConfig): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/integration`, config);
  }
}
